import * as config from "config";
import { LINKEDIN_POPUP_BROWSING_CONTEXT } from "modules/auth/constants";
import logger from "logging/logger";
import { FirebaseAuthError } from "testUtils/error";
import { PreferredLoginError } from "modules/auth/types";
import { fetchSignInMethodsForEmail } from "firebase/auth";
import { firebaseAuth } from "services/firebaseService/firebaseConfig";
import signInWithToken from "../signInWithToken";
import waitForTokenInLocalStorage from "../waitForTokenInLocalStorage";

export const LINKEDIN_AUTH_REDIRECT_ENDPOINT = `${config.getAPIUrl()}/linkedin-auth/redirect`;

const signInWithLinkedin = async () => {
  window.open(
    LINKEDIN_AUTH_REDIRECT_ENDPOINT,
    LINKEDIN_POPUP_BROWSING_CONTEXT,
    "width=600,height=600,scrollbars=no,resizable=no,location=no,toolbar=no,menubar=no,left=500,top=300",
  );

  try {
    // the result is set in the Callback component
    const token = await waitForTokenInLocalStorage();

    return signInWithToken(token);
  } catch (error) {
    if (error instanceof FirebaseAuthError) {
      logger.info(
        "[socialAuth][signInWithLinkedin] Account error. Existing email attempting to signIn with a different provider",
      );
      const methods = await fetchSignInMethodsForEmail(
        firebaseAuth,
        error.customData.email,
      );
      throw new PreferredLoginError(
        "auth/account-exists-with-different-credential",
        methods,
      );
    }

    // otherwise, throw upwards
    throw error;
  }
};

export default signInWithLinkedin;
